module.exports = __webpack_public_path__ + "img/partner_logo3.6c4c0175.png";